module.exports = __webpack_public_path__ + "img/certificate1.ee173b56.jpg";